<template>
  <component
    :is="estrategia.componente"
    :comp="comp"
    :citt-id="cittId"
    :editable="editable"
    v-bind="estrategia.propiedades"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { IFormComponent } from '@/modules/Configuracion/interfaces/IFormComponent'
import type {
  IEstrategiaListaSql,
  TipoVisualizacionListaSql
} from '@/modules/Configuracion/interfaces'
import { resolverVisualizacionListaSql } from '@/modules/Configuracion/utils/listaSql'
import ListaSqlBotonModal from '@/modules/Core/components/ListaSql/ListaSqlBotonModal.vue'
import ListaSqlTablaModal from '@/modules/Core/components/ListaSql/ListaSqlTablaModal.vue'
import ListaSqlGraficaDirecta from '@/modules/Core/components/ListaSql/ListaSqlGraficaDirecta.vue'

const props = defineProps<{
  comp: IFormComponent
  cittId?: number
  editable?: boolean
}>()

const estrategias: Record<TipoVisualizacionListaSql, IEstrategiaListaSql> = {
  BOTON_MODAL: { componente: ListaSqlBotonModal, propiedades: {} },
  TABLA_MODAL: { componente: ListaSqlTablaModal, propiedades: {} },
  GRAFICA_BARRAS: {
    componente: ListaSqlGraficaDirecta,
    propiedades: { tipoGrafica: 'bar' }
  },
  BOTON_MODAL_GRAFICA_BARRAS: {
    componente: ListaSqlBotonModal,
    propiedades: { tipoGrafica: 'bar' }
  },
  GRAFICA_CIRCULAR: {
    componente: ListaSqlGraficaDirecta,
    propiedades: { tipoGrafica: 'doughnut' }
  },
  BOTON_MODAL_GRAFICA_CIRCULAR: {
    componente: ListaSqlBotonModal,
    propiedades: { tipoGrafica: 'doughnut' }
  }
}

const estrategia = computed(() => {
  const visualizacion = resolverVisualizacionListaSql(props.comp.properties?.visualizacion)
  return estrategias[visualizacion]
})
</script>
